const initialState = {
	isLoading: 0,
	errors: {},
	data: {}
}

export default (state = initialState, action) => {
	switch (action.type){
		case 'CONTENT_LOADING':
			return {
				...state,
				errors: {},
				isLoading: 1,
				data: {}
			}
		case 'CONTENT_HAS_ERROR':
			return {
				...state,
				isLoading: 0,
				errors: action.errors
			}
		case 'CONTENT_SUCCESS':
			return {
				...state,
				isLoading: 0,
				data: action.data
			}

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/store/reducers/content.js